
import React, { Component } from 'react';

import './../../../scss/App.scss';
import * as Utils from './../../utils/utils';


class WinPanel extends Component {

	constructor(props){
		super(props);

		this.state = {

		}
	}

	componentDidMount(){

		// update cookie
		Utils.updateCompletedPuzzlesCookie(window.ppz.puzzleData.title);

		//

		window.TweenMax.set(this.refs.panel, {transform:"translateY(10vh)"});
		window.TweenMax.to(this.refs.panel, 1, {transform:"translateY(0vh)"});

		// show confetti
		window.ppz.overlayManager.showConfetti();
		
	}

	componentWillUnmount(){
		// remove confetti
		window.ppz.overlayManager.hideConfetti();
	}

	render(){

		return (
			<div id="winPanel" ref="panel">
				<div className="heading">Congrats you solved this People Puzzler!</div>
				<div className="body">
					<div className="line">A new Puzzle will be available each day or you can UNLOCK All of the People Puzzles of this week.</div>
					<div className="selectPuzzleBtn" onClick={() => window.ppz.overlayManager.setPanel("puzzleSelect")}>Play Another Puzzle</div>
				</div>
				<div className="closeBtn" onClick={() => window.ppz.overlayManager.closeOverlay()}>
					<div className="x"></div>
				</div>
			</div>
		);
	}
}

export default WinPanel;


// WEBPACK FOOTER //
// ./src/js/components/overlays/WinPanel.js